import React from 'react'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';

// The grip is an affordance: this marker can be dragged in the planned view.
// It takes no handler of its own, so in actual mode, where nothing here can be
// moved, it is a control that does nothing and it comes off.
function DailyBreakCard({ draggable = true }) {
  return (
    <div className="w-full h-full bg-slate-900 opacity-40 flex items-center justify-center">
      {draggable && (
        <div className="text-slate-900 w-full">
          <DragIndicatorIcon />
        </div>
      )}
    </div>
  )
}

export default DailyBreakCard
